const Contact = () => {
	return (
		<>
			<div className="flex justify-center my-10">
				<div className="card w-96 bg-base-100 shadow-2xl shadow-accent">
					<div className="card-body">
						<h2 className="card-title">Contact me!</h2>
						<p>
							If you have <i>any</i> questions, or would like to know more,
							please dont hesitate to contact me! I am more than happy to get in
							touch.
						</p>
						<br />
						<span>
							<b>Email:</b> agnep344@gmail.com
						</span>
						<div className="divider">Or</div>
						<span>
							<b>Phone:</b> (+353) 89 453 2282
						</span>
					</div>
				</div>
			</div>
		</>
	);
};
export default Contact;
